import type { ComponentStyle } from "@yamada-ui/core"

export const Icon: ComponentStyle<"Icon"> = {
  baseStyle: {
    color: "currentColor",
    display: "inline-block",
    flexShrink: 0,
    h: "1em",
    lineHeight: "1em",
    w: "1em",
  },
}
